export function root(bid: string): string {
	return `/brands/${bid}/brandguard`
}

export function score(bid: string): string {
	return `${root(bid)}/score`
}

export namespace approval {
	export function upload(bid: string): string {
		return `${root(bid)}/approval`
	}

	export function review(bid: string): string {
		return `${root(bid)}/approval/review`
	}

	export function approved(bid: string): string {
		return `${root(bid)}/approval/approved`
	}

	export function rejected(bid: string): string {
		return `${root(bid)}/approval/rejected`
	}
}
